var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0299 4.36499C13.0649 4.36499 9.02989 8.39999 9.02989 13.365V17.7C9.02989 18.615 8.63989 20.01 8.17489 20.79L6.44989 23.655C5.38489 25.425 6.11989 27.39 8.06989 28.05C14.5349 30.21 21.5099 30.21 27.9749 28.05C29.7899 27.45 30.5849 25.305 29.5949 23.655L27.8699 20.79C27.4199 20.01 27.0299 18.615 27.0299 17.7V13.365C27.0299 8.41499 22.9799 4.36499 18.0299 4.36499Z",
    stroke: "#0082CD",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8039 4.79997C20.3389 4.66497 19.8589 4.55997 19.3639 4.49997C17.9239 4.31997 16.5439 4.42497 15.2539 4.79997C15.6889 3.68997 16.7689 2.90997 18.0289 2.90997C19.2889 2.90997 20.3689 3.68997 20.8039 4.79997Z",
    stroke: "#0082CD",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5312 28.59C22.5312 31.065 20.5062 33.09 18.0312 33.09C16.8013 33.09 15.6612 32.58 14.8512 31.77C14.0412 30.96 13.5312 29.82 13.5312 28.59",
    stroke: "#0082CD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBig);
export default __webpack_public_path__ + "static/media/notification-big.e7192f68b2c19dcd480b1a5c1cbfc5e0.svg";
export { ForwardRef as ReactComponent };